/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Field, Form } from 'formik';
import { Button, Col, Label, Row } from 'reactstrap';
import { ADD_EDIT_CONSTANT, dynamicButtonHeading } from 'utils/constants';
import CardWithTitle from 'components/CardWithTitle';
import FormikInputField from 'components/Fields/FormikInputField';
// import AddressField from 'components/AddressField';
import CallingCodeField from 'components/CallingCodeField';
import LoadingButton from 'components/common/LoadingButton';
import ReactSelect from 'components/Fields/ReactSelect';

const accessOptions = [
  {
    value: 'FULL_ACCESS',
    label: 'Full Access',
    description: 'Can view, create, edit, and manage everything across the organization',
  },
  {
    value: 'EDIT_ACCESS',
    label: 'Edit Access',
    description: 'Can create offers/demands but can\'t modify bid/orders data.',
  },
  {
    value: 'VIEW_ACCESS',
    label: 'View Access',
    description: 'Can only view offers/demands. No edit or create rights.',
  },
];

const formatOptionLabel = ({ label, description }, { context }) => (
  <div>
    <div style={{ fontWeight: '500', color: '#333' }}>{label}</div>
    {context === 'menu' && (
      <div style={{ fontSize: '13px', color: '#666', marginTop: '2px' }}>
        {description}
      </div>
    )}
  </div>
);

const AdditionalUserForm = (props) => {
  const {
    handleSubmit,
    setFieldValue,
    values,
    type,
    drawerToggle,
    isValid,
    dirty,
    isSubmitting,
  } = props;

  const handlePhoneChange = (event) => {
    const numericPhone = event.target.value.replace(/\D/g, '').slice(0, 10);
    setFieldValue('phone', numericPhone, true);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <CardWithTitle title="User Detail">
        <Row>
          <Col md={6}>
            <Field
              label="First Name"
              name="firstName"
              type="text"
              component={FormikInputField}
              required
            />
          </Col>
          <Col md={6}>
            <Field
              label="Middle Name (Optional)"
              name="middleName"
              type="text"
              component={FormikInputField}
            />
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Field
              label="Last Name"
              name="lastName"
              type="text"
              component={FormikInputField}
              required
            />
          </Col>
          <Col md={6}>
            <Row>
              <Col sm={12}>
                <Label>
                  Phone Number<span className="text-danger">*</span>
                </Label>
              </Col>
              <CallingCodeField
                id="callingCode"
                name="callingCode"
                label=""
                required
              />
              <Col className="w-100">
                <Field
                  id="phone"
                  name="phone"
                  label=""
                  type="text"
                  component={FormikInputField}
                  disabled={values?.callingCode?.id ? false : true}
                  maxLength={10}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  onChange={handlePhoneChange}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Field
          label="Email"
          name="email"
          type="text"
          component={FormikInputField}
          required
        />
        <Field
          name="access"
          component={ReactSelect}
          data={accessOptions}
          label="User Access"
          required
          formatOptionLabel={formatOptionLabel}
          placeholder="Select user access"
        />
      </CardWithTitle>

      {/* <AddressField values={values} setFieldValue={setFieldValue} required /> */}

      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
          onClick={() => drawerToggle('', ADD_EDIT_CONSTANT.ADD)}
        >
          Cancel
        </Button>
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          disabled={!isValid || !dirty || isSubmitting}
          color="warning"
          size="sm"
          type="submit"
        >
          {dynamicButtonHeading(type)}
        </LoadingButton>
      </div>
    </Form>
  );
};

export default AdditionalUserForm;
